<div class="container d-flex flex-column flex-grow-1 w-100 align-items-center pb-20">
  @if (isSuccess) {
    <div class="progress-section d-flex flex-column w-100">
      <!-- Bubbles and connecting lines row -->
      <div class="d-flex align-items-center justify-content-center w-100 gap-4 ps-25 pe-25">
        @for (step of progressSteps; track step; let i = $index; let last = $last) {
          <div
            class="step-indicator"
          [ngClass]="{
            completed: step.completed,
            current: step.current,
            pending: !step.completed && !step.current,
          }"
            >
            <span>{{ i + 1 }}</span>
          </div>
          <!-- Connecting line (not after last step) -->
          @if (!last) {
            <div class="progress-line" [ngClass]="{ completed: step.completed }"></div>
          }
        }
      </div>
      <div class="w-100 d-flex">
        @for (step of progressSteps; track step; let i = $index; let first = $first; let last = $last) {
          <div
            class="step-label"
        [ngClass]="{
          completed: step.completed,
          current: step.current,
          pending: !step.completed && !step.current,
          'text-start': first,
          'text-center': !first && !last,
          'text-end': last,
        }"
            >
            {{ step.title }}
          </div>
        }
      </div>
    </div>
  }

  <!-- Content Area -->
  <div class="mt-32 d-flex flex-column align-items-center flex-grow-1" [@fadeAnimation]>
    @if (!isSuccess) {
      <div class="final-step">
        <div class="icon">🙁</div>
        <div class="failed-title mt-20 w-100" i18n="@@paymentFailed">
        Unfortunately, your payment did not go through.
      </div>
        <button
          [routerLink]="retryUrl"
          mat-flat-button
          class="tagus w-100 mt-20"
          i18n="@@tryAgain"
          >
        Try again
      </button>
      </div>
    }

    @if (isSuccess && isUpsellStep()) {
      @if (isLoadingUpsell) {
        <div
          class="d-flex align-items-center justify-content-center flex-grow-1 w-100"
          >
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }
      @if (!isLoadingUpsell && getCurrentUpsellOffer(); as offer) {
        <app-upsell
          [offer]="offer"
          (onAction)="onUpsellAction($event.action, $event.offer)"
        ></app-upsell>
      }
    }

    <!-- Final Step - App Download (or straight back into the web app) -->
    @if (isSuccess && isFinalStep()) {
      <app-download [continueUrl]="continueUrl"></app-download>
    }
  </div>
</div>
